import React, { useContext } from "react";
import { MainSection, Section, SectionTitle, Card } from "../common_components/Layout";
import { PrimaryButton } from "../common_components/Buttons";
import { useNavigate } from "react-router-dom";
import { ResearcherContext } from "../../../ResearcherContext";

function WelcomeRow(props) {
    const navigate = useNavigate();
    const NUMBERSESSIONSHIGHLIGHTED = 5;
    const { researcher, setResearcher, refreshResearcher } = useContext(ResearcherContext);




    return (
        <div className="welcome-row">
            <div className="welcome-text" >
                Welcome, <span className="welcome-emphasis-text">{researcher.first_name}</span>
            </div>
            <PrimaryButton text="Create New Project" onClick={() => navigate("/createmission/")} />
        </div>

    )
}

export default WelcomeRow;